import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { translationChunksConfig } from "@spartacus/assets";
import { I18nModule, provideConfig } from "@spartacus/core";
import { provideOutlet, OutletPosition } from "@spartacus/storefront";
import { CustomCollaborationComponent } from "./custom-collaboration.component";
import { CustomInternalTabComponent } from "./custom-internal-tab/custom-internal-tab.component";
import { CustomProceduresTabComponent } from "./custom-procedures-tab/custom-procedures-tab.component";
import { CustomTrainingTabComponent } from "./custom-training-tab/custom-training-tab.component";

@NgModule({
  declarations: [CustomCollaborationComponent, CustomTrainingTabComponent, CustomProceduresTabComponent, CustomInternalTabComponent],
  imports: [
    CommonModule,
    I18nModule
    // ConfigModule.withConfig({
    //   cmsComponents: {
    //     CommunicationComp: {
    //       component: CustomCollaborationComponent,
    //     },
    //   },
    //   i18n: {
    //     backend: { loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json' },
    //   },
    //   chunks: translationChunksConfig,
    // } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'CommunicationComp',
      position: OutletPosition.REPLACE,
      component: CustomCollaborationComponent,
    }),
    provideOutlet({
      id: 'TrainingComp',
      position: OutletPosition.REPLACE,
      component: CustomTrainingTabComponent,
    }),
    provideOutlet({
      id: 'BusinessPlans-left',
      position: OutletPosition.REPLACE,
      component: CustomProceduresTabComponent,
    }),
    provideOutlet({
      id: 'Internalreportsandcommunications-left',
      position: OutletPosition.REPLACE,
      component: CustomInternalTabComponent,
    }),
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class CustomCollaborationModule { }


